<template>
    <div class="row">
        <div class="col-6 mx-auto my-auto">
            <mdb-card>
                <!--<mdb-card-image src="https://mdbootstrap.com/img/Photos/Horizontal/Nature/4-col/img%20%286%29.jpg" alt="Card image cap"></mdb-card-image>-->
                <mdb-card-body>
                    <mdb-card-title tag="h3" align="center">Введіть код доступу</mdb-card-title>
                    <!--<chapter tag="h4" class="card-title mt-0">Введіть код доступу</chapter>-->
                    <mdb-card-text>
                        <div class="alert alert-warning text-center" role="alert">
                            Будь-ласка введіть 16-ти значний код доступу.
                        </div>
                    </mdb-card-text>
                    <mdb-card-text>
                        <auth-by-code />
                    </mdb-card-text>
                    <!--<mdb-btn color="primary">Button</mdb-btn>-->
                </mdb-card-body>
            </mdb-card>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'auth-by-code-card',
        data() {
            return {};
        },
        methods: {}
    }
</script>

<style scoped>

</style>
